import { useEffect, useState, useCallback } from "react";
import api from "../lib/api";
import { PageHeader } from "../components/AppLayout";
import { StatusBadge } from "../components/Badges";
import KnowledgeDetail from "../components/KnowledgeDetail";

export default function Constitution() {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);

  const load = useCallback(() => api.get("/knowledge?type=CONSTITUTION").then((r) => setItems(r.data)), []);
  useEffect(() => { load(); }, [load]);

  return (
    <div>
      <PageHeader title="The Constitution" subtitle="The highest authority in PRAMAANA. Nothing of lower authority may override these clauses." />
      <div className="p-10">
        <div className="max-w-3xl space-y-3" data-testid="constitution-list">
          {items.map((it, i) => (
            <button
              key={it.id}
              data-testid={`constitution-item-${it.knowledge_id}`}
              onClick={() => setSelected(it.id)}
              className="w-full text-left bg-white border border-slate-200 p-6 hover:border-slate-400 transition-colors duration-150 fade-in"
              style={{ animationDelay: `${i * 8}ms` }}
            >
              <div className="flex items-center gap-3 mb-2">
                <span className="font-mono text-sm text-slate-700 bg-slate-100 px-2 py-0.5 rounded-sm">{it.knowledge_id}</span>
                <StatusBadge status={it.status} />
              </div>
              <h3 className="font-serif text-2xl text-slate-900 leading-tight mb-1">{it.title}</h3>
              <p className="text-sm text-slate-600 leading-relaxed line-clamp-2">{it.statement}</p>
            </button>
          ))}
        </div>
      </div>
      <KnowledgeDetail itemId={selected} open={!!selected} onClose={() => setSelected(null)} onChanged={load} />
    </div>
  );
}
